<template>
    <div>
        <d-recipients-edit
            v-model       = "create"
            :recipient-id = "-1"
            :customer-id  = "customerId"
            @saved        = "onCreated"
        />
        <c-card-iterator
            :label         = "title"
            v-if           = "items"
            :items         = "items"
            :filter-height = "150"
            :item-height   = "190"
            :min-height    = "topSpace"
            :height        = "height"
            :filter        = "itemFilter"
            :enable-search = "false"
            :zoom          = "enableZoom"
            :left-arrow    = "leftArrow"
            :header-color  = "headerColor"
            class          = "w-100"
            @zoom          = "onZoom"
            @remove-filter = "onRemoveFilter"
        >
            <template v-slot:toolbar>
                <div class="pl-1" style="margin-top: -2px">
                    <c-toolbar-button
                        :size    = "24"
                        icon     = "mdi-plus"
                        color    = "white"
                        :tooltip = "$t('msd.recipient.create')"
                        @click   = "onCreate"
                    />
                </div>
            </template>
            <template v-slot:filter>
                <c-recipient-card-filter
                    :filter          = "filter"
                    :color           = "headerColor"
                    @changed         = "onFilter"
                />
            </template>
            <template v-slot:card="{ item }">
                <c-recipient-card
                    @selected        = "onSelected"
                    @edit            = "onEditRecipient"
                    @saved           = "onSaved"
                    style            = "width: calc(100% - 1px)"
                    :highlight-color = "color(item)"
                    :company         = "item"
                    :background      = "selected && selected.id === item.id ? 'card-preselected' : null"
                />
            </template>
        </c-card-iterator>
    </div>
</template>

<script>

import Core                 from "@/modules/core/service/Core";
import CCardIterator        from "@/modules/core/components/utils/CCardIterator";
import CRecipientCard       from "@/modules/msd/company/recipient/components/CRecipientCard";
import CRecipientCardFilter from "@/modules/msd/company/recipient/components/CRecipientCardFilter";
import CToolbarButton       from "@/modules/core/components/utils/CToolbarButton";
import DRecipientsEdit      from "@/modules/msd/company/recipient/components/DRecipientsEdit";
import Recipients           from "@/modules/msd/company/recipient/service/Recipients";

export default {
    name: "CRecipientCardIterator",
    components: {
        DRecipientsEdit,
        CToolbarButton,
        CRecipientCardFilter,
        CCardIterator,
        CRecipientCard
    },

    props: {
        title: {
            required: false,
            type    : String,
            default : function () {
                return "Leistungs-/Rechnungsempfänger";
            }
        },

        customerId: {
            required: false,
            type    : Number,
            default : function () {
                return null;
            }
        },

        recipients: {
            required: false,
            type    : Array,
            default : function () {
                return [];
            }
        },

        lim: {
            required: false,
            type    : Boolean,
            default : function () {
                return true;
            }
        },

        inc: {
            required: false,
            type    : Boolean,
            default : function () {
                return false;
            }
        },

        enableZoom: {
            required: false,
            type    : Boolean,
            default : function () {
                return true;
            }
        },

        topSpace: {
            required: false,
            type    : Number,
            default : function () {
                return null;
            }
        },

        height: {
            required: false,
            type    : Number,
            default : function () {
                return null;
            }
        },

        enableEdit: {
            required: false,
            type    : Boolean,
            default : function () {
                return true;
            }
        },

        leftArrow: {
            required: false,
            type    : Boolean,
            default: function () {
                return true;
            }
        },

        headerColor: {
            required: false,
            type    : String,
            default : function () {
                return "primary";
            }
        },
    },

    data: () => ({
        selected: null,
        create  : false,
        items   : [],
        filter  : {
            text           : "",
            lim            : true,
            inc            : true,
            benefit        : false,
            invoice        : false,
            usedOnIncidents: false,
            usedOnRepair   : false,
            usedOnCosts    : false,
            active         : true,
            inactive       : false
        }

    }),

    computed: {

    },

    mounted() {
        this.initialize();
    },

    watch: {
        customerId() {
            this.initialize();
        },

        recipients () {
            this.initialize();
        }
    },

    methods: {
        initialize () {
            this.filter.lim = this.lim;
            this.filter.inc = this.inc;

            if (!this.customerId && !this.recipients) {
                return;
            }

            if (this.customerId) {
                Recipients.list(this.customerId, (data) => {
                    this.items = data;
                })
            } else {
                this.items = this.recipients;
            }
        },

        onEditRecipient (recipient) {
            this.$emit("edit", recipient);
        },

        onZoom () {
            this.$emit("zoom");
        },

        onFilter () {
        },

        onRemoveFilter () {

        },

        onCreate () {
            this.create = true;
        },

        onCreated (recipient) {
            this.items.unshift(recipient);
        },

        onSaved () {

        },

        onSelected (value) {
            if (this.selected && this.selected.id === value.id) {
                this.selected = null;
                Core.fire.selected(this, null);
                return;
            }

            this.selected = value;
            Core.fire.selected(this,  value);
        },

        itemFilter (item) {
            let hit = false;
            if (this.filter.text && this.filter.text.length > 0) {
                if (item.id && ("" + item.id).includes(this.filter.text)) {
                    hit = true;
                }

                if (item.name && item.name.includes(this.filter.text)) {
                    hit = true;
                }

                if (item.nameAdd && item.nameAdd.includes(this.filter.text)) {
                    hit = true;
                }

                if (item.street && item.street.includes(this.filter.text)) {
                    hit = true;
                }

                if (item.city && item.city.includes(this.filter.text)) {
                    hit = true;
                }

                if (item.zip && item.zip.includes(this.filter.text)) {
                    hit = true;
                }
            } else {
                hit = true;
            }

            if (!hit) {
                return false;
            }

            if ((this.filter.active && !this.filter.inactive) || (!this.filter.active && this.filter.inactive)) {
                if (this.filter.active && item.status.id !== 1) {
                    return false;
                }

                if (this.filter.inactive && item.status.id === 1) {
                    return false;
                }
            }

            if (!this.filter.active && !this.filter.inactive) {
                return false;
            }

            if (this.filter.lim && !item.liftmanagement) {
                return false;
            }

            if (this.filter.inc && !item.incidentmanagement) {
                return false;
            }

            if (this.filter.invoice && !item.invoice) {
                return false;
            }

            if (this.filter.benefit && !item.benefit) {
                return false;
            }

            if (this.filter.usedOnIncidents && !item.usedOnIncidents) {
                return false;
            }

            if (this.filter.usedOnRepair && !item.usedOnRepair) {
                return false;
            }

            if (this.filter.usedOnCosts && !item.usedOnCosts) {
                return false;
            }

            return true;
        },

        color (item) {
            if (!item) {
                return null;
            }

            return item.status.id === 1 ? this.headerColor : 'secondary'
        }
    }
}
</script>

<style scoped>


</style>